import React, { useCallback, useState, useEffect } from 'react';

import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import dayjs from 'dayjs';
import { MyApplicationComment, MyApplicationDetail } from '../../api/openapi';
import { applicationApi } from '../../api';
import ApplicationCommentBox from './ApplicationCommentBox';

interface Props {
  item: MyApplicationDetail;
}

// interface Values {
//   comment: string | undefined;
// }

const ApplicationCommentCreate: React.FC<Props> = ({ item }: Props) => {
  const { t } = useTranslation(['viewApplication', 'common']);
  const [data, setData] = useState<MyApplicationComment[] | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const getApplicationComments = useCallback(() => {
    setLoading(true);

    applicationApi
      .myApplicationCommentList({
        application: item.id,
      })
      .then((response) => {
        setData(response.data);
      })
      .catch(() => {
        setError(true);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [item.id]);

  useEffect(() => {
    getApplicationComments();
  }, [getApplicationComments]);

  if (error) {
    return <>{t('common:kerfisvilla')}</>;
  }

  if (loading || data == null) {
    return (
      <>
        <FontAwesomeIcon spin icon={faSpinner} />
      </>
    );
  }

  return (
    <>
      {/* <Formik<Values>
        initialValues={{
          comment: '',
        }}
        validateOnBlur={false}
        // validateOnChange={false}
        // validationSchema={validationSchema}
        // enableReinitialize
        onSubmit={async (values: Values, { setSubmitting, setFieldError }: FormikHelpers<Values>) => {
          try {
            await applicationApi.applicationCommentCreate({
              application: item.id,
              applicationCommentRequest: {
                comment: values.comment,
              },
            });

            toast.success(t('commentSaved'));
            getApplicationComments();
          } catch (e) {
            restValidationToForm({
              t,
              error: e,
              setFieldError,
              errorFieldMap: {
                comment: 'comment',
              },
            });
          } finally {
            setSubmitting(false);
          }
        }}
      >
        {({ values, touched, errors, getFieldProps, setFieldValue, handleReset, setStatus, handleSubmit }): React.ReactElement => (
          <Form
            noValidate
            onReset={handleReset}
            onSubmit={(e: React.FormEvent<HTMLFormElement>): void => {
              setStatus('submitted');
              handleSubmit(e);
            }}
          > */}
      <Row>
        <Col md="4">
          <p className="small text-muted">{t('commentHelp')}</p>
        </Col>
        <Col md="8">
          {item.interviewDateTime && (
            <strong className="text-uppercase">
              {t('interview')}: {item.interviewLocation}, {dayjs(item.interviewDateTime).format('DD.MM.YYYY HH:mm')}
            </strong>
          )}
          <div className="pb-5">
            {data?.map((c) => (
              <div key={c.id}>
                <ApplicationCommentBox item={c} />
              </div>
            ))}
          </div>
          {/* <Form.Group controlId="comment">
                  <Form.Label className="textBold">{t('comment')}:</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={5}
                    type="text"
                    className={classNames({
                      'is-invalid': touched.comment && errors.comment,
                    })}
                    {...getFieldProps('comment')}
                  />
                </Form.Group>
                <hr />
                <Button
                  variant="primary"
                  type="button"
                  onClick={() => {
                    setStatus('submitted');
                    handleSubmit();
                  }}
                >
                  {t('common:save')}
                </Button> */}
        </Col>
      </Row>
      {/* </Form>
        )}
      </Formik> */}
    </>
  );
};
export default ApplicationCommentCreate;
